/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
 getGridDateOperators,
 getGridNumericOperators,
 getGridStringOperators,
 GridColDef,
 GridRenderCellParams,
 GridValueFormatter,
 GridValueGetter,
} from '@mui/x-data-grid-premium';
import dayjs from 'dayjs';

import { StructureType } from '../../../types/types';
import {
 findStructure,
 getTranslation,
 isJson,
 resolveObjPathDots,
} from '../../../utils/dataTypes';
import xRenderCell from './renderCell';

const typesMap = {
 int32: 'number',
 int16: 'number',
 boolean: 'boolean',
 double: 'number',
 enum: 'singleSelect',
 decimal: 'number',
 string: 'string',
 datetime: 'dateTime',
 model: 'string',
 array: 'string',
 actions: 'actions',
};

export const renderColObj = (
 col: GridColDef,
 headerName: string,
 structure?: StructureType, // ? because 'actions' has no structure
 renderCell?: (params: GridRenderCellParams<any>) => JSX.Element,
 valueGetter?: (value: GridValueGetter) => object,
): GridColDef => {
 //  console.log(
 //   getGridDateOperators(true).map((item) => ({
 //    ...item,
 //    InputComponent: DateTimeFilter,
 //    InputComponentProps: { showTime: true },
 //   })),
 //  );

 const nameVar = isJson(structure?.ForeignKeyDefaultFilter || '')
  ? JSON.parse(structure?.ForeignKeyDefaultFilter || '').fields.split(',')[1]
  : 'Name';

 const colType =
  structure?.Type === 'model'
   ? structure?.InnerStructure?.find((item) => item.Name === nameVar)?.Type
   : structure?.Type;

 const getRightOperators = () => {
  let output = [];
  switch (structure?.Type) {
   case 'datetime':
    output = getGridDateOperators(true).filter((o) =>
     ['onOrBefore', 'onOrAfter', 'between'].includes(o.value),
    );
    break;
   case 'int32':
   case 'int16':
   case 'double':
   case 'decimal':
    output = getGridNumericOperators().filter((o) =>
     ['=', '!=', '<=', '>='].includes(o.value),
    );
    break;
   case 'enum':
    output = getGridStringOperators().filter((o) =>
     ['equals', 'doesNotEqual', 'contains', 'isAnyOf'].includes(o.value),
    );
    break;
   case 'model':
    output = getGridStringOperators().filter((o) =>
     ['equals', 'doesNotEqual', 'isAnyOf'].includes(o.value),
    );
    break;
   case 'string':
    output = getGridStringOperators().filter((o) =>
     ['equals', 'doesNotEqual', 'contains', 'isAnyOf'].includes(o.value),
    );
    break;
   default:
    output = getGridStringOperators().filter((o) =>
     ['equals', 'doesNotEqual', 'contains'].includes(o.value),
    );
  }
  // console.log('getRightOperators', structure?.Type, col.field, output);
  return output;
 };

 return {
  field: col.field,
  headerName,
  headerClassName: ['model', 'datetime'].includes(structure?.Type || '')
   ? 'model-header'
   : '',
  valueFormatter: (params: GridValueFormatter, row: any) => {
   if (structure?.Type === 'model') {
    // console.log('iff', row[col.field], nameVar);
    return row[col.field]?.[nameVar] || 'wrong name for model';
   }
   return params;
  },
  groupingValueGetter: (params: { [key: string]: any }) =>
   params?.[nameVar] || params, // params need to be value, row
  valueGetter: (value: any, row: any) => {
   const res = resolveObjPathDots(row, col.field);
   const finalVal = value || res;

   if (structure?.Type === 'model') {
    if (res && typeof res === 'object' && nameVar in res) {
     return res[nameVar as keyof typeof res];
    }
    return value;
   }
   if (valueGetter) {
    return valueGetter(finalVal);
   }
   if (structure?.Type === 'datetime') {
    return finalVal ? dayjs(finalVal).toDate() : null;
   }
   return resolveObjPathDots(row, col.field);
  },
  groupable: true,
  aggregable: true,
  type:
   col.field === 'actions'
    ? 'actions'
    : (typesMap as any)?.[colType || 'string'],
  width: col.width || undefined,
  minWidth: col.field === 'actions' ? 56 : 100,
  maxWidth: col.field === 'actions' ? 56 : 250,
  headerAlign: 'left',
  align: 'left',
  sortComparator: (v1, v2, cellParams1, cellParams2) => {
   console.log('sortComparator', v1, v2, cellParams1, cellParams2);
   return 1;
  },
  filterOperators: getRightOperators(),
  //  filterOperators:
  //   (defaultFilterOperators[type as string] as unknown as GridFilterOperator[]) ||
  //   defaultFilterOperators.string, // Apply default filter operators
  //  flex: 1, // disables horizontal scroll
  renderCell: (params: GridRenderCellParams<any>) =>
   renderCell
    ? renderCell(params)
    : xRenderCell(params, col.field, structure?.Type || 'number'),

  // ...(structure?.Type === 'model'
  //  ? {
  //     filterOperators: [modelEqualFilterOperator, modelNotEqualFilterOperator],
  //    }
  //  : null),
  // ...(structure?.Type === 'datetime'
  //  ? {
  //     filterOperators: [
  //      {
  //       InputComponent: DateTimeFilter,
  //       // InputComponentProps: { showTime: true },
  //       // this doesn't work, see addLogicToFilters
  //       value: 'onOrBefore',
  //       getApplyFilterFn: (filterItem, column) => {
  //        console.log('xxxxxxxxxxxxxxxx', filterItem, column);
  //        if (!filterItem.field || !filterItem.value || !filterItem.operator) {
  //         return null;
  //        }

  //        return (value, row, coll, apiRef) =>
  //         Number(value) >= Number(filterItem.value);
  //       },
  //      },
  //     ],
  //    }
  //  : null),
  // ...(structure?.Type === 'enum'
  //  ? {
  //     valueOptions: Object.keys(structure.EnumValues).map((key) => ({
  //      value: key,
  //      label: structure.EnumValues[key],
  //     })),
  //    }
  //  : null),
 };
};

export const renderColWithStructure = (
 columns: GridColDef[],
 structure: StructureType[],
) => {
 //  console.log('renderColWithStructure', columns, structure);
 let output = [] as GridColDef[];
 if (!structure.length) {
  throw new Error('renderColWithStructure Structure is empty');
 }
 if (!Array.isArray(columns)) {
  return [];
 }
 columns?.forEach((col) => {
  if (col.field === 'actions') return;
  const structureObj = findStructure(structure, col.field);

  if (!structureObj) return;

  const colName = getTranslation(structure, col.field);
  // console.log('renderColWithStructure');

  if (structureObj.Type === 'model') {
   const nameVar = isJson(structureObj.ForeignKeyDefaultFilter || '')
    ? JSON.parse(structureObj.ForeignKeyDefaultFilter || '').fields.split(
       ',',
      )[1]
    : 'Name';

   const colType =
    structureObj?.Type === 'model'
     ? structureObj?.InnerStructure?.find((item) => item.Name === nameVar)?.Type
     : structureObj?.Type;

   output.push(
    renderColObj(
     col,
     colName,
     structureObj,
     (params: GridRenderCellParams<any>) => {
      const customValue = resolveObjPathDots(
       params.row,
       `${col.field}.${nameVar}`,
      );
      return xRenderCell(
       params,
       colName,
       colType || 'string',
       String(customValue),
      );
     },
     (value: GridValueGetter) => resolveObjPathDots(value, col.field),
    ) as GridColDef,
   );
  } else if (structureObj.Type === 'array') {
   const nameVar = isJson(structureObj.ForeignKeyDefaultFilter || '')
    ? JSON.parse(structureObj.ForeignKeyDefaultFilter || '').fields.split(
       ',',
      )[1]
    : 'Name';

   const colType = structureObj?.InnerStructure?.find(
    (item) => item.Name === nameVar,
   )?.Type;

   output.push(
    renderColObj(
     col,
     colName,
     structureObj,
     (params: GridRenderCellParams<any>) => {
      const customValue =
       params.row[col.field]?.map((item: any) => item[nameVar]).join(', ') ||
       '';
      return xRenderCell(params, colName, colType || 'number', customValue);
     },
    ) as GridColDef,
   );
  } else if (structureObj.Type === 'enum') {
   output.push(
    renderColObj(
     col,
     colName,
     structureObj,
     (params: GridRenderCellParams<any>) =>
      xRenderCell(
       params,
       colName,
       structureObj.Type,
       structureObj.EnumValues[params.value],
      ),
    ) as GridColDef,
   );
  } else {
   //  console.log(
   //   'renderColObj',
   //   colName,
   //   renderColObj(col, colName, structureObj),
   //  );
   output.push(renderColObj(col, colName, structureObj) as GridColDef);
  }
 });
 //  console.log(output);
 return output;
};
